import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQuery } from 'src/store/redux';

import { AllEnrollmentResponse, GradesMESResponse } from './types';
import { normalizeEntrywaysGradesResponse } from './utils';

export const entrywaysApi = createApi({
  reducerPath: 'entryways',
  baseQuery: baseQuery('entryways'),
  endpoints: (builder) => ({
    getSchoolsAndGradesMES: builder.query<GradesMESResponse, void>({
      query: () => ({
        url: '/graphql',
        method: 'POST',
        body: JSON.stringify({
          query: `
        query getSchoolsAndGrades {
            getAllEnrollment_v2 {
              districts {
                schools {
                  studentsByGrade {
                    grade
                  }
                }
              }
            }
          }
        `,
        }),
      }),
      transformResponse: ({ data }: { data: AllEnrollmentResponse }) =>
        normalizeEntrywaysGradesResponse(data),
    }),
  }),
});

export const { useGetSchoolsAndGradesMESQuery } = entrywaysApi;
